module.exports = __webpack_public_path__ + "img/1-vidio.8f1afbdf.jpg";